import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';
import { PathSectionType } from '@/types/schema';

interface SectionDetailsProps {
  section: PathSectionType;
}

function SectionDetails(props: SectionDetailsProps) {
  const { t } = useTranslation();
  const { section } = props;

  return (
    <Stack direction="col">
      <Typography className="mb-4" color="text-text-secondary" variant="label-caps">
        {t('AssignmentCreator:SectionIndex', { index: section.order })}
      </Typography>
      <Typography variant="label-01">{section.name}</Typography>
    </Stack>
  );
}

export default SectionDetails;
